import styles from './SCarDetaiTermsAndConditionsSection.module.scss';

const SCarDetaiTermsAndConditionsSection = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default SCarDetaiTermsAndConditionsSection;
